import { Controller } from '@hotwired/stimulus'

// Enable hidden field which unsets the value in database when all records are deleted
// Enabled delete field with other records causes invalid parameters
export default class extends Controller {
  static targets = ['input', 'record']

  recordTargetConnected(_target) {
    this.inputTarget.disabled = true
  }

  recordTargetDisconnected(_target) {
    if (this.recordTargets.length ===  0) {
      this.inputTarget.disabled = false
    }
  }
}
